import React from "react";

function BasePage({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div className="flex flex-col justify-center min-h-screen py-6 bg-gray-50 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-5xl">
          <div className="bg-white py-3 px-4 shadow sm:rounded-lg sm:px-10">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

export default BasePage;
